import { NavLink } from 'react-router-dom';
import { cn } from '@/utils/cn';
import { NAV_ITEMS } from './nav';

/** The pages people open most, one tap away on phones; everything else is in the menu. */
const TABS = ['Dashboard', 'Insights', 'Expenses', 'Subscriptions', 'Tags'];

export function MobileTabBar() {
  const tabs = NAV_ITEMS.filter((i) => TABS.includes(i.label));
  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-40 border-t border-border bg-card/95 backdrop-blur lg:hidden"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
      aria-label="Main"
    >
      <ul className="grid grid-cols-5">
        {tabs.map((item) => (
          <li key={item.to}>
            <NavLink
              to={item.to}
              className={({ isActive }) =>
                cn('flex flex-col items-center gap-0.5 py-2 text-[11px] font-medium', isActive ? 'text-primary' : 'text-muted-foreground')
              }
            >
              <item.icon className="h-5 w-5" />
              <span className="max-w-full truncate px-1">{item.label === 'Subscriptions' ? 'Subs' : item.label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
